// extracted by mini-css-extract-plugin
export default {"tab":"styles_tab__OQzk8","section":"styles_section__tY8b5","actionBtn":"styles_actionBtn__7GwKg"};